var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.lessons && _vm.lessons.length > 0)?_c('active-lesson-controls'):_vm._e(),_c('div',{staticClass:"pb-16 pt-8"},[(_vm.shouldShowOtherLessons)?_c('other-lessons-list'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }